import { render, staticRenderFns } from "./extra-detail.vue?vue&type=template&id=395814dc&"
import script from "./extra-detail.vue?vue&type=script&lang=js&"
export * from "./extra-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports